<template>
    <div @click="bar.backshow = false, bar.colourshow = false">
        <h5>Sale Bar Messages</h5>
        <div class="mb-3 mt-3">
            <div class="mb-2">
                Sale Bar Colours:
            </div>
            <div class="d-flex mb-2">
                <div class="mr-2" v-for="(colour, index) in colours" style="width:100px;">
                    <input type="text" v-model="colours[index]" @change="change_colour()" class="form-control">
                </div>
            </div>
            <div class="mb-1" v-for="(message, index) in sale_send" v-if="message.location.name == 'Sale Bar'">
                <div ref="toolbar">
                    <vue-editor v-if="renderComponent" v-model="message.message" :editorToolbar="customToolbar" @focus="change_array('id', message.id)"></vue-editor>
                </div>
                <div>
                    <div class="btn btn-danger pointer btn-sm mt-1" @click="change_array('delete', message.id), delete_msg(index, message.id)">Delete message <i class="far fa-trash-alt text-white"></i></div>
                </div>
            </div>
            <button class="btn btn-info mb-2 btn-sm" @click="add_msg('bar')"><i class="fas fa-plus"></i>&nbsp; Add message</button>
            <div class="position-relative colour-picker mb-2">
                <div class="d-flex align-items-center">
                    <div class="mr-2">
                        Background:
                    </div> 
                    <div style="width:100px;" class="mr-2">
                        <input type="text" v-model="bar.background" @keyup="change_array('colour')" class="form-control">
                    </div>
                    <div style="width:36px;height:36px;" :style="'background:' + bar.background" class="border border-secondary"></div>
                </div>
            </div>
        </div>
        <!-- Blinds Direct IE: no thumb / product form messages (its PLP and PDP badges are the discount in
             the sale bar's colours); the Home Banner section below is IE's only -->
        <h5 v-if="!bdie">Thumb Messages</h5>
        <div class="mb-3 mt-3" v-if="!bdie">
            <template v-for="(message, index) in sale_send" v-if="message.location.name == 'Product Thumbnail'">
                <div class="form-group input-group">
                    <input type="text" class="form-control" placeholder="Thumbnail Message" v-model="message.message" @change="change_array('id', message.id)">
                    <select class="form-control ml-2" v-model="message.group.id" @change="change_array('id', message.id)">
                        <option :value="null">All Products</option>
                        <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                    </select>
                    <button class="btn btn-danger ml-2" @click="delete_msg(index, message.id)"><i class="far fa-trash-alt text-white"></i></button>
                </div>
                <div class="position-relative colour-picker mb-4">
                    <div class="d-flex align-items-center">
                        <div class="mr-2">
                            Text Colour:
                        </div> 
                        <div style="width:100px;" class="mr-2">
                            <input type="text" v-model="message.data[0].value" @input="change_array('id', message.id)" class="form-control">
                        </div>
                        <div style="width:36px;height:36px;" :style="'background:' + message.data[0].value" class="border border-secondary"></div>           
                    </div>
                </div>
            </template>
            <button class="btn btn-info mt-2 btn-sm" @click="add_msg('thumb')"><i class="fas fa-plus"></i>&nbsp; Add message</button>
        </div>
        <h5 v-if="!bdie">Product Form Messages</h5>
        <div class="mb-3 mt-3" v-if="!bdie">
            <div class="form-group input-group" v-for="(message, index) in sale_send" v-if="message.location.name == 'Product Form'">
                <input type="text" class="form-control" placeholder="Product Form Message" v-model="message.message" @change="change_array('id', message.id)">
                <select class="form-control ml-2" v-model="message.group.id" @change="change_array('id', message.id)">
                    <option :value="null">All Products</option>
                    <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                </select>
                <button class="btn btn-danger ml-2" @click="delete_msg(index, message.id)"><i class="far fa-trash-alt text-white"></i></button>
            </div>
            <button class="btn btn-info mt-2 btn-sm" @click="add_msg('form')"><i class="fas fa-plus"></i>&nbsp; Add message</button>
        </div>
        <h5 v-if="bdie">Home Banner</h5>
        <div class="mb-3 mt-3" v-if="bdie">
            <div class="text-muted small mb-2">The copy on the homepage hero banner (Blinds Direct Ireland): the small line above the headline, the headline, and the button. The headline accepts HTML (e.g. <code>&lt;br&gt;</code>, <code>&lt;strong&gt;</code>, <code>&amp;amp;</code>). Blank colours / size keep the site's defaults; a blank link uses the banner's own link.</div>
            <template v-for="(message, index) in sale_send" v-if="message.location.name == 'Home Banner'">
                <div class="form-group input-group">
                    <input type="text" class="form-control" placeholder="Eyebrow (e.g. Do it together)" v-model="message.home.name" @input="change_array('id', message.id)">
                    <input type="text" class="form-control ml-2" placeholder="Headline (e.g. Enjoy 15% off all items)" v-model="message.message" @input="change_array('id', message.id)">
                </div>
                <div class="form-group input-group">
                    <input type="text" class="form-control" placeholder="Button text (e.g. Shop now)" v-model="message.home.button" @input="change_array('id', message.id)">
                    <input type="text" class="form-control ml-2" placeholder="Button link (e.g. /roller-blinds)" v-model="message.home.link" @input="change_array('id', message.id)">
                </div>
                <div class="d-flex flex-wrap align-items-center mb-4">
                    <div class="d-flex align-items-center mr-4 mb-2" v-for="field in homeStyleFields">
                        <div class="mr-2 text-nowrap">{{ field.label }}:</div>
                        <div style="width:100px;" class="mr-2">
                            <input type="text" :placeholder="field.placeholder" v-model="message.home[field.key]" @input="change_array('id', message.id)" class="form-control">
                        </div>
                        <!-- the swatch is the browser's colour picker; it needs #rrggbb, so the typed value is expanded for it -->
                        <input v-if="field.colour" type="color" class="home-colour-picker border border-secondary" title="Pick a colour"
                            :value="homeHex(message.home[field.key] || field.placeholder)"
                            @input="message.home[field.key] = $event.target.value; change_array('id', message.id)">
                    </div>
                    <button class="btn btn-danger mb-2" @click="delete_msg(index, message.id)"><i class="far fa-trash-alt text-white"></i></button>
                </div>
                <!-- a rough live preview (the site's own fonts aren't loaded here): desktop and mobile -->
                <div class="d-flex flex-wrap align-items-start mb-4">
                    <div class="home-preview home-preview-desktop mr-3 mb-2" :style="homePreviewStyle(message, false)">
                        <div class="home-preview-name" :style="{fontSize: homeSize(message.home.name_size, '14px')}" v-html="message.home.name"></div>
                        <div class="home-preview-message" :style="{color: message.home.colour || '#ffffff'}" v-html="message.message"></div>
                        <span class="home-preview-button" :style="{background: message.home.button_background || '#CCBDA6', color: message.home.button_colour || '#4A2B21'}">{{ message.home.button || 'Shop now' }} &rarr;</span>
                    </div>
                    <div class="home-preview home-preview-mobile mb-2" :style="homePreviewStyle(message, true)">
                        <div class="home-preview-name" :style="{fontSize: homeSize(message.home.name_size, '14px')}" v-html="message.home.name"></div>
                        <div class="home-preview-message" :style="{color: message.home.colour || '#ffffff'}" v-html="message.message"></div>
                        <span class="home-preview-button" :style="{background: message.home.button_background || '#CCBDA6', color: message.home.button_colour || '#4A2B21'}">{{ message.home.button || 'Shop now' }} &rarr;</span>
                    </div>
                </div>
            </template>
            <button class="btn btn-info mt-2 btn-sm" v-if="!sale_send.some(message => message.location.name == 'Home Banner')" @click="add_msg('home')"><i class="fas fa-plus"></i>&nbsp; Add banner copy</button>
        </div>
        <div>
            <button class="btn btn-danger mr-1" @click="closeSection"><i class="far fa-times-circle"></i>&nbsp; Close</button>
            <button class="btn btn-primary mr-1" @click="save()"><i class="far fa-save"></i>&nbsp; Save</button>
            <button class="btn btn-success" @click="save('close')"><i class="fas fa-save"></i>&nbsp; Save &amp; close</button> 
        </div>
        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import VueCountdown from '@chenfengyuan/vue-countdown';
import loader from './loader.vue';
import { VueEditor, Quill } from "vue2-editor";



export default {

    components: {
        VueCountdown,
        loader,
        VueEditor
    },

    data() {
        return {
            sale_send: {},
            groups: {},
            locations: [],
            // the home banner's optional styling, saved in the message's data by key
            homeStyleFields: [
                {key: 'size', label: 'Headline size', placeholder: '56px', colour: false},
                {key: 'size_mobile', label: 'Headline size (mobile)', placeholder: '40px', colour: false},
                {key: 'name_size', label: 'Eyebrow size', placeholder: '14px', colour: false},
                {key: 'colour', label: 'Headline colour', placeholder: '#ffffff', colour: true},
                {key: 'button_background', label: 'Button colour', placeholder: '#CCBDA6', colour: true},
                {key: 'button_colour', label: 'Button text colour', placeholder: '#4A2B21', colour: true},
            ],
            changed: [],
            deleted: [],
            axios_array: [],
            colours: ['#ffffff', '#000000', '#0033cc', '#009933', '#ff3300'],
            bar: {
                background: '#454545',
                foreground: '#ffffff',
            },
            renderComponent: true,
            loading:true,
            load_count: 0,
            customToolbar: [["bold", "italic", "underline"], [{ color: [] }], ['clean']]
        };
    },

    props: {
        sale: Object,
    },

    computed: {
        // a Blinds Direct IE sale (website 118): sale bar and home banner only
        bdie(){
            return (this.sale.websites || []).some(website => website.id == 118);
        },
    },

    mounted(){
        this.sale_send = this.sale.messages;

        this.get_groups();
        this.get_locations();
         
        history.pushState({page: 0}, "", window.location.pathname + "?page=messages");  

        this.update_messages();

        for(let message in this.sale_send){
            if(this.sale_send[message].location.name == 'Sale Bar'){
                this.bar.background = this.sale_send[message].data[0].value;
                this.bar.foreground = this.sale_send[message].data[1].value;
            }
        }
        this.customToolbar[1][0].color = this.colours;
        this.loading_count();

        setTimeout(() => {
            this.$refs.toolbar[0].children[0].children[1].children[0].style.background = this.bar.background
        },100);        
    },

    methods: {
        change_colour(){            
            this.customToolbar[1][0].color = this.colours;
            this.renderComponent = false;
            this.$nextTick(() => {
                this.renderComponent = true;
            });
        },
        save(close) {
            let group;
            let colourData
            this.loading_count();
            if(this.load_count > 0){
                this.loading = true;
            } else if(close){
                this.closeSection();
            }
            if(this.deleted.length > 0){
                for(let del in this.deleted){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/messages/' + this.deleted[del]))
                }
            }
            for(let message in this.sale_send){
                group = null;
                if(this.sale_send[message].group.id != null){
                    group = this.sale_send[message].group.id;
                } 
                colourData = null;
                if(this.sale_send[message].location.name == "Sale Bar"){
                    colourData = {
                        background: this.bar.background,
                        foreground: this.bar.foreground,
                    }
                } else if(this.sale_send[message].location.name == "Product Thumbnail"){
                    colourData = {
                        foreground: this.sale_send[message].data[0].value,
                    }
                } else if(this.sale_send[message].location.name == "Home Banner"){
                    colourData = {};
                    for(let key of this.homeKeys()){
                        colourData[key] = this.sale_send[message].home[key] || '';
                    }
                }
                if(this.changed.includes(this.sale_send[message].id) && this.sale_send[message].id){
                    this.axios_array.push(axios.patch('/sales/' + this.sale.id + '/messages/' + this.sale_send[message].id,{
                        location_id: this.sale_send[message].location.id,
                        group_id: group,
                        message: this.sale_send[message].message,
                        data: colourData,
                    }))
                } else if(!this.sale_send[message].id){
                    this.axios_array.push(axios.post('/sales/' + this.sale.id + '/messages', 
                    {
                        location_id: this.sale_send[message].location.id,
                        group_id: group,
                        message: this.sale_send[message].message,
                        data: colourData,
                        headers: {
                            'content-type': 'multipart/form-data',
                        },
                    }))
                }
            }
            axios.all(this.axios_array)            
            .then(function (responses){   
                if(responses.length > 0){   
                    axios.get('/sales/' + this.sale.id)
                    .then(function (response) {
                        this.sale_send = response.data.sale.messages;
                        this.check_load(close);                        
                        this.update_messages();             
                    }.bind(this))
                    .catch(function (error) {
                        alert(error);
                    })                
                }
            }.bind(this));
        },
        closeSection (event) {
            history.pushState({page: 0}, "", window.location.pathname); 
            this.$emit('closeChild', false);
        },
        get_groups: function(){
            axios.get('/groups/list')
            .then(function (response) {
                this.groups = response.data.groups;
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
            })
        },
        // a typed colour as the #rrggbb the colour picker needs (#000 -> #000000; anything else -> black)
        homeHex(value){
            value = (value || '').toString().trim();
            if(/^#[0-9a-f]{3}$/i.test(value)){
                return '#' + value[1] + value[1] + value[2] + value[2] + value[3] + value[3];
            }
            return /^#[0-9a-f]{6}$/i.test(value) ? value.toLowerCase() : '#000000';
        },
        // a size field as CSS: "60" or "60px" -> 60px, blank -> the default
        homeSize(value, fallback){
            value = (value || '').toString().trim();
            if(value == ''){
                return fallback;
            }
            return /^\d+(\.\d+)?$/.test(value) ? value + 'px' : value;
        },
        // the preview's headline size: desktop as set (default 56px), mobile as set or 0.72 x desktop (as home.scss)
        homePreviewStyle(message, mobile){
            let desktop = this.homeSize(message.home.size, '56px');
            let size = mobile ? this.homeSize(message.home.size_mobile, 'calc(' + desktop + ' * 0.72)') : desktop;
            return {'--preview-size': size};
        },
        // every data key the home banner message carries: the copy and the styling fields
        homeKeys(){
            return ['name', 'button', 'link'].concat(this.homeStyleFields.map(field => field.key));
        },
        get_locations: function(){
            axios.get('/locations/list')
            .then(function (response) {
                this.locations = response.data.locations;
            }.bind(this))
            .catch(function (error) {
                alert(error);
            })
        },
        add_msg(type){
            if(type == 'home'){
                let location = this.locations.find(location => location.slug == 'home-banner');
                if(!location){
                    alert('The "Home Banner" location is missing - run the sales system migrations.');
                    return;
                }
                let home = {};
                for(let key of this.homeKeys()){
                    home[key] = key == 'button' ? 'Shop now' : '';
                }
                this.sale_send.push(
                    {
                        data: {},
                        home: home,
                        group: {id: null},
                        location: location,
                        message: '',
                    }
                );
            } else if(type == 'bar'){
                this.sale_send.push(
                    {
                        data: {
                            0: {
                                key: 'background',
                                value: this.bar.background,
                            },
                            1: {
                                key: 'foreground',
                                value: this.bar.foreground,
                            }
                        },
                        group: {id: null},
                        location: {
                            name: 'Sale Bar',
                            slug: 'sale-bar',
                            id: 1
                        },
                        message: '',
                    }
                );
            } else if(type == 'thumb'){
                this.sale_send.push(
                    {
                        data: {
                            0: {
                                key: 'foreground',
                                value: '#454545',
                            },
                        },
                        group: {id: null},
                        location: {
                            name:"Product Thumbnail",
                            slug:"product-thumbnail",
                            id: 2
                        },
                        colourshow: false,                        
                        message: '',
                    }
                );
            } else{
                this.sale_send.push(
                    {
                        group: {id: null},
                        location: {
                            name:"Product Form",
                            slug:"product-form",
                            id: 5
                        },
                        message: '',
                    }
                );
            }
        },
        change_array(type, id){ 
            this.$refs.toolbar[0].children[0].children[1].children[0].style.background = this.bar.background;   
            if(type == 'colour'){ 
                for(let message in this.sale_send){
                    if(this.sale_send[message].location.name == 'Sale Bar'){
                        if(!this.changed.includes(this.sale_send[message].id)){
                            this.changed.push(this.sale_send[message].id);
                        }
                    }
                }
            } 
            if(id){        
                if(type == 'id'){
                    if(!this.changed.includes(id)){
                        this.changed.push(id);
                    }
                }                
                if(type == 'delete'){
                    const index = this.changed.indexOf(id);
                    if (index > -1) {
                        this.changed.splice(index, 1);
                    }
                }
            }
        },
        delete_msg(index, id){
            this.sale_send.splice(index, 1);  
            if(id){
                this.deleted.push(id);
            }
        },
        update_messages(){
            for(let message in this.sale_send){
                if(this.sale_send[message].group == null){
                    Vue.set( this.sale_send[message], 'group', {'id':null});
                }
                // the home banner's eyebrow / button / link live in the message's data (key, value)
                if(this.sale_send[message].location.name == 'Home Banner'){
                    let home = {};
                    for(let key of this.homeKeys()){
                        home[key] = '';
                    }
                    for(let datum of Object.values(this.sale_send[message].data || {})){
                        if(datum.key in home){
                            home[datum.key] = datum.value;
                        }
                    }
                    Vue.set(this.sale_send[message], 'home', home);
                }
            }
        },
        loading_count(){
            let loadCount = this.changed.length + this.deleted.length;
            for(let message in this.sale_send){
                if(!this.sale_send[message].id){
                    loadCount++;
                }
            }
            this.load_count = loadCount;
        },
        check_load(close){
            this.loading = false;
            this.changed = [];
            this.deleted = [];
            this.axios_array = [];
            if(close == 'close'){
                this.closeSection();
            }
        },
    },
};
</script>

<style>
/* the home banner preview: the IE hero's layout (dark photo, eyebrow, serif headline, pill
   button) at a reduced scale - Georgia stands in for the site's serif */
.home-preview {
    background: #1f1d1b linear-gradient(90deg, #1f1d1b 60%, #3a2f29);
    color: #fff;
    padding: 32px 24px;
    border-radius: 4px;
    font-family: Helvetica, Arial, sans-serif;
    overflow: hidden;
}
.home-preview-desktop { width: 620px; max-width: 100%; min-height: 220px; }
.home-preview-mobile  { width: 260px; min-height: 260px; }
.home-preview-name {
    color: #CCBDA6;
    text-transform: uppercase;
    margin-bottom: 10px;
}
.home-preview-message {
    font-family: Georgia, 'Times New Roman', serif;
    font-size: var(--preview-size, 56px);
    line-height: 1.1;
    max-width: 8.5em;
    margin-bottom: 24px;
}
.home-colour-picker {
    width: 36px;
    height: 36px;
    padding: 2px;
    background: #fff;
    cursor: pointer;
}
.home-preview-button {
    display: inline-block;
    padding: 12px 24px;
    border-radius: 100px;
    font-weight: 500;
    font-size: 14px;
}
</style>
